// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-routes-Account-DataViewer-loader__loading--2lI1L{display:flex;align-content:center;align-items:center}.src-routes-Account-DataViewer-loader__loading--2lI1L>div{width:100%}.src-routes-Account-DataViewer-loader__loading--2lI1L .src-routes-Account-DataViewer-loader__error--qosFO{color:#fff;margin-left:auto;margin-right:auto;width:auto;padding:20px;background:#f60;min-width:50%;max-width:90%;text-align:center}.src-routes-Account-DataViewer-loader__loading--2lI1L .src-routes-Account-DataViewer-loader__error--qosFO>pre{margin:0;margin-top:10px;overflow:auto;background:#eee;color:#000;padding:10px;text-align:left}\n", ""]);
// Exports
exports.locals = {
	"loading": "src-routes-Account-DataViewer-loader__loading--2lI1L",
	"error": "src-routes-Account-DataViewer-loader__error--qosFO"
};
module.exports = exports;
